import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { createPortal } from "react-dom";
import {LuX} from "react-icons/lu";

const variantStyles = {
  default: "bg-white text-slate-900 border border-slate-200",
  dark: "bg-slate-900 text-white border border-slate-800",
  success: "bg-green-600 text-white border border-green-700",
  error: "bg-red-600 text-white border border-red-700",
};

const toastVariants = {
  initial: { y: 50, opacity: 0, scale: 0.95 },
  animate: { y: 0,  opacity: 1, scale: 1 },
  exit:    { y: 50, opacity: 0, scale: 0.95 },  // siempre baja
};

const Toast = ({
  text,
  duration = 3000,
  variant = "default",
  open = true,
  onClose,
}) => {

  useEffect(() => {
    if (!open) return;
    const timer = setTimeout(() => onClose?.(), duration);
    return () => clearTimeout(timer);
  }, [open, duration, onClose]);

  // Renderiza el Toast en un portal fuera del flujo normal del DOM
  return createPortal(
    <AnimatePresence>
      {open && (
        <motion.div
          variants={toastVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={{ type: "spring", stiffness: 400, damping: 30 }}
          onClick={() => onClose?.()}               // cerrar al tocar
          className="fixed left-1/2 z-[9999] flex justify-center w-full px-6 cursor-pointer"
          style={{ bottom: 50, translateX: "-50%" }}
        >
          <div
            className={`w-full max-w-[400px] flex flex-row gap-2 p-4 rounded-2xl shadow-2xl select-none cursor-pointer ${
              variantStyles[variant] || variantStyles.default
            }`}
          >
            <span className="flex-1 block text-sm font-normal">{text}</span>
            <LuX  size={20}/>
          </div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body
  );
};

export default Toast;
